<div class="objet-lecteur-container">
  <div class="lecteur-container">
    <p class="name">{{terminal.name}}</p>
    <small class="last-used">{{lastUsedDate}}</small>
  </div>
  <div class="tags-container">
    <lua-tag *ngIf="cetAppareil" label="Cet appareil" mode="outlined" color="Gris3"></lua-tag>
    <lua-tag *ngIf="deviceType && deviceColor" [label]="deviceType" [color]="deviceColor"></lua-tag>
  </div>
</div>